// import axiosApi from "../axiosInstance";

// const getLocationList = async () => {
//     try {
//         const response = await axiosApi.get(`/AssetLocation/getLocation`);
//         return response?.data;

//     } catch (error) {
//         console.log("Error getLocationList===>:", error);
//          return error?.response?.data;
//     }
// };

// const addLocation = async (body) => {
//     try {
//         const response = await axiosApi.post(`AssetLocation/createLocation`, body);
//         return response?.data;
//     } catch (error) {
//         console.log("Error addLocation ===>", error);
//          return error?.response?.data;
//     }
// };

// export const assetLocationService = {
//     getLocationList,
//     addLocation
// }
import axiosApi from "../axiosInstance";

const getLocationList = async (projectId) => {
  try {
    const response = await axiosApi.get(
      `/AssetLocation/getLocation/${projectId}`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getLocationList===>:", error);
    return error?.response?.data;
  }
};

const addLocation = async (body) => {
  try {
    const response = await axiosApi.post(`AssetLocation/createLocation`, body);
    return response?.data;
  } catch (error) {
    console.log("Error addLocation ===>", error);
    return error?.response?.data;
  }
};

//project

//avatarClasses

export const assetLocationService = {
  getLocationList,
  addLocation,
};
